/**
 * Build a compact list of page numbers with ellipsis for pagination.
 * Always shows first and last page, current page ± 1, with "..." for gaps.
 * Example: page 5 of 20 -> [1, "...", 4, 5, 6, "...", 20]
 *
 * @param {number} current - Current page number (1-based)
 * @param {number} total  - Total number of pages
 * @returns {Array<number|string>} Array of page numbers and "..." strings
 */
export const buildPageList = (current, total) => {
  if (total <= 0) return [];
  if (total <= 7) {
    // If 7 or fewer pages, show all
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages = new Set([1, total, current, current - 1, current + 1]);
  const result = [];
  const sorted = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);

  for (let i = 0; i < sorted.length; i++) {
    result.push(sorted[i]);
    if (i < sorted.length - 1 && sorted[i + 1] - sorted[i] > 1) {
      result.push('...');
    }
  }

  return result;
};

export default buildPageList;